import script from "./add-permission.vue?vue&type=script&setup=true&lang=js"
export * from "./add-permission.vue?vue&type=script&setup=true&lang=js"

import "./add-permission.vue?vue&type=style&index=0&id=683e422e&lang=css"

const __exports__ = script;

export default __exports__